import type {
  LC_GetConceptGenerationProgressOut,
  ConceptGenerationProgress,
} from '../types';


// Transporte → modelo de dominio que consume la celda de acciones del listado.
// Reduce el DTO a los campos que la UI necesita para decidir entre barra, menú y error.
export const mapConceptGenerationProgress = (
  out: LC_GetConceptGenerationProgressOut,
): ConceptGenerationProgress => ({
  monthlyCutId: out.monthlyCutId,
  progressPercentage: out.progressPercentage,
  isActive: out.isActive,
  isCompleted: out.isCompleted,
  hasError: out.hasError,
  errorMessage: out.errorMessage ?? null,
});
